<script>
import { userDropdown } from "../../navigation"

export default {
    data: () => ({
        userDropdown
    }),
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        roleUser() {
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            role = typeof role === "string" ? role : role[0]

            return role
        },
    }
}
</script>
<template>
    <a-dropdown>
        <div class="header-user" style="cursor: pointer;">
            <a-avatar class="avatar" size="small" shape="circle">{{ initial(user().name) }}</a-avatar>
            <span class="name">{{ user().name }}</span>
        </div>
        <a-menu :class="['avatar-menu']" slot="overlay">
            <a-menu-item>
                <a :href="routeUri('admin.setting.profile.show', {user_hash: user().hash})">
                    <span>
                        <a-icon type="user" />
                        <strong>{{ roleUser }}</strong>
                    </span>
                    <span style="display:block;">
                        {{ user().email }}
                    </span>
                </a>
            </a-menu-item>
            <a-menu-item v-for="item in userDropdown" :key="item.route">
                <a :href="routeUri(item.route)">
                    <a-icon :type="item.icon" />
                    <span>{{ item.text }}</span>
                </a>
            </a-menu-item>
        </a-menu>
    </a-dropdown>
</template>
